/* DS-BOGO v6 — fill timeline dates from the visitor's own date.
   Offsets come from data attrs (theme-editor settings). */
(function () {
  function ordinal(n) {
    var v = n % 100;
    if (v >= 11 && v <= 13) return n + 'th';
    return n + ({1: 'st', 2: 'nd', 3: 'rd'}[n % 10] || 'th');
  }
  function fmt(d) {
    return d.toLocaleString('en-US', { month: 'short' }) + ' ' + ordinal(d.getDate());
  }
  function plusDays(days) {
    var d = new Date();
    d.setDate(d.getDate() + days);
    return d;
  }
  function init(el) {
    if (el.hasAttribute('data-tl-init')) return;
    el.setAttribute('data-tl-init', '1');
    var dispatch = parseInt(el.getAttribute('data-tl-dispatch'), 10) || 0;
    var dMin = parseInt(el.getAttribute('data-tl-del-min'), 10) || 0;
    var dMax = parseInt(el.getAttribute('data-tl-del-max'), 10) || dMin;
    var dates = {
      0: fmt(plusDays(0)),
      1: fmt(plusDays(dispatch)),
      2: dMin === dMax ? fmt(plusDays(dMin)) : fmt(plusDays(dMin)) + ' - ' + fmt(plusDays(dMax)),
    };
    el.querySelectorAll('[data-tl-date]').forEach(function (s) {
      var i = s.getAttribute('data-tl-date');
      if (dates[i] != null) s.textContent = dates[i];
    });
  }
  function boot() { document.querySelectorAll('[data-ve-bogo-tl]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
